export function affiliated( value: string ){
    return value.toLowerCase() === "yes";
}